/* global _rollbarConfig */
// FIXME - move all to site entry

import './lib/console-message';

import 'expose-loader?moment!moment';
import 'expose-loader?Cookies!js-cookie';
import 'expose-loader?React!react';
import 'expose-loader?ReactDOM!react-dom';
import 'expose-loader?async!async';

import {__} from 'site/i18n';

import tracker from 'tracker';

window.tracker = tracker;

import './less/compile.less';

tracker.ready(() => {
  if (analytics.timeout) analytics.timeout(500);
});



// WEBPACK FOOTER //
// ./site/index.jsx